import i18n from '../../lang/index'
const whiteRouter = [{
  path: '/white',
  component: () => import('@/pages/Index'),
  redirect: {
    name: 'whiteindex'
  },
  children: [{
      name: 'whiteindex',
      path: 'list',
      component: () => import('@/pages/white/WhiteList'),
      meta: {
        tab: '',
        title:i18n.t('whitelist.title'),
      },
    },
    {
      name: 'whitedatail',
      path: 'detail',
      component: () => import('@/pages/white/WhiteDetail'),
      meta: {
        tab: '',
      },
    },
    {
      name: 'addwhite',
      path: 'add',
      component: () => import('@/pages/white/AddWhite'),
      meta: {
        tab: '',
      },
    },
  ]
}]
export default whiteRouter



// WEBPACK FOOTER //
// ./src/router/modules/whitelist.js